import { inject, Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { AnalyticsService } from '../analytics/analytics.service';
import { Job } from './job';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class JobService {
  private analyticsService = inject(AnalyticsService);
  private alertController = inject(AlertController);
  private loadingController = inject(LoadingController);
  private router = inject(Router);

  create<T>(job: () => Promise<T>) {
    return new Job<T>(
      job,
      this.analyticsService,
      this.alertController,
      this.loadingController,
      this.router,
    );
  }
}
